import { AppRoute, OAuthGrants } from '@ebeihilfe/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { environment } from '../../../../environments/environment';

const menuItems = [
  {
    route: '/' + AppRoute.PinValidation,
    ariaLabel: _('a11y.link.settings'),
    label: _('menu.label.settings'),
  },
  {
    route: '/' + AppRoute.Settings + '/' + AppRoute.SettingsChangeEmail,
    ariaLabel: 'a11y.link.changeEmail',
    label: 'menu.label.changeEmail',
    grantGuard: (grants) => grants.has('password'),
  },
  {
    route: '/' + AppRoute.Settings + '/' + AppRoute.SettingsNewPin,
    ariaLabel: 'a11y.link.requestNewPin',
    label: 'menu.label.requestNewPin',
  },
  {
    route: '/' + AppRoute.Settings + '/' + AppRoute.SettingsChangePassword,
    ariaLabel: 'a11y.link.changePassword',
    label: 'menu.label.changePassword',
    grantGuard: (grants) => grants.has('password'),
  },
  {
    route: '/' + AppRoute.Settings + '/' + AppRoute.SettingsDeleteAccount,
    ariaLabel: 'a11y.link.deleteUser',
    label: 'menu.label.deleteUser',
  },
] as AccountMenuItem[];

if (environment.sentry) {
  menuItems.push({
    route: '/' + AppRoute.Settings + '/' + AppRoute.SettingsPrivacy,
    ariaLabel: 'a11y.link.privacy_settings',
    label: 'menu.label.privacy',
  });
}

export default menuItems;

export interface AccountMenuItem {
  route: string;
  ariaLabel: string;
  label: string;
  grantGuard?: (grants: Set<OAuthGrants>) => boolean;
}
